import script from "./LessonPlanEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonPlanEdit.vue?vue&type=script&setup=true&lang=js"

import "./LessonPlanEdit.vue?vue&type=style&index=0&id=a6e043a8&lang=less&scoped=true"
script.__scopeId = "data-v-a6e043a8"

export default script